import { createContext } from "react";

const SessionInformationContext = createContext();

export default SessionInformationContext;